import PlainCard from "@/components/plainCard";
import { BENEFITS_CONSTANTS } from "./constants";

const BenefitsComponent = () => {
  return <PlainCard {...BENEFITS_CONSTANTS} />;
};

export default BenefitsComponent;
